import React from 'react';
import { Link } from 'react-router-dom';
import { servicePages } from '../data/servicesData';
import { locationPages } from '../data/locationsData';
import { blogSlugs } from '../data/blogData';

/**
 * Sitemap Component for react-snap crawler
 * This component provides all internal links for react-snap to discover and prerender
 * It's visually hidden but allows the crawler to find all routes
 */
const Sitemap = () => {
  return (
    <div style={{ display: 'none' }} aria-hidden="true">
      <h2>Sitemap - All Pages</h2>
      
      {/* Service Pages */}
      <div>
        <h3>Service Pages</h3>
        <ul>
          {servicePages.map((slug) => (
            <li key={slug}>
              <Link to={`/${slug}`}>{slug}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Location Pages */}
      <div>
        <h3>Location Pages</h3>
        <ul>
          {locationPages.map((slug) => (
            <li key={slug}>
              <Link to={`/${slug}`}>{slug}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Blog Pages */}
      <div>
        <h3>Blog Pages</h3>
        <ul>
          {blogSlugs.map((slug) => (
            <li key={slug}>
              <Link to={`/blog/${slug}`}>{slug}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sitemap;
